// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const frontendDrawerWidth = '100vw';
export const appDrawerWidth = 320;
